const UserIcon = ({ size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="4" stroke="#1976d2" strokeWidth="2"/>
    <path d="M4 20v-2a6 6 0 0 1 12 0v2" stroke="#1976d2" strokeWidth="2"/>
  </svg>
);
export default UserIcon;